<template>
    <div>
    <span class="Maintitle"> 
    <h4><small class="text-muted">
             <i class="fas fa-envelope"></i> <strong> Contact Us : </strong> 
           
    </small></h4>  
    </span> 
    <!-- <span class="Maintitle">
    <i class="fas fa-clinic-medical"></i>
    <strong> Medical Supplies and Services Claims Application (MSSCS) </strong>
    </span> -->
    <Card>
      <CardBody>
           <!-- For information on Supplementary Health/Family Health policies, procedures, claims submission, registration for MSSCS contact: -->

            
        <div class="row mt-1">  
          <div class="col-12 col-lg-10">
            <TileCard>
              <template slot="header">For information on Supplementary Health/Family Health policies, procedures, claims submission, payments, registration for MSSCS contact:</template>
              <template slot="body">
                <address>
                  Telephone: 1-800-266-0695 or 306-787-3124 (in Regina) Hours:  Monday – Fridays, 8 am to 5pm<br><br>
                  Drug Plan and Extended Benefits Branch<br> Ministry of Health<br> 2nd floor - 3475 Albert Street<br> Regina, SK S4S 6X6<br>
                  Email: supphealth@health.gov.sk.ca<br>
                  <!-- <abbr title="Email">Email</abbr>: supphealth@health.gov.sk.ca<br> -->
                </address>
              </template>
            </TileCard>
            <TileCard>
              <template slot="header">For MSSCS financial and claims username password resets, issues with login or network (system down) issues contact:</template>
              <template slot="body">
                <address>
                  CGI HelpDesk (24/7 availability)<br>
                  1-800-667-6080<br> 306-761-4286<br>
                  *please indicate that you are calling about MSSCS <br>
                  <!-- <abbr title="Email">Email</abbr>: supphealth@health.gov.sk.ca<br> -->
                </address>
              </template>
            </TileCard>
          </div>
        </div>

      </CardBody>
        </Card>
</div>
</template>
<script>
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import TileCard from "@/Common/TileCard.vue";
import { mapGetters } from 'vuex';
export default  {
     props:{
        error:''
     }, //['ServiceID','msg', 'MenuArray','error'],
  data: function () {
      
    return {
 
        }
    },
    components: { 
              Card,
            CardBody,
            TileNote,
            TileCard           
        },
    mounted: function () {
    this.$nextTick(function () {  
    })
    },
    created: function() { 
        //this.$emit('update:layout', LoginLayout);
        //console.log('at Dental Main home')
        //this.menuitems = this.$store.getters.GetMainMenu; 
    },
    computed:{
        ...mapGetters({
                GetMessage: 'GetMessage',
                ShowLoginMsg: 'ShowLoginMsg'
            }),
        errorMsg: {
           get(){
             return this.GetMessage
           },
           set(newName){
             return newName
           } 
        }, 
        ...mapGetters({
                 
                ShowLoginMsg: 'ShowLoginMsg'
            }),
        ShowMsg: {
           get(){
             return this.ShowLoginMsg
           },
           set(val){
             return val
           } 
        },
    },
    watch: {
    ShowMsg: function (val) {
        //console.log (val)
        if(val)
        {
            //this.showMsg1("Seesion","","Con")
        }
        },
    },
    methods: {
    HideMsg: function(val){
        this.$store.dispatch('ResetLoginMSg');
        this.$bvModal.hide('modal-sm');
        },
    showMsg1(msg,data,Title) {
        this.boxTwo = ''
        this.$bvModal.msgBoxOk(msg, {
        title: Title,
        size: 'md',
        buttonSize: 'md',
        okVariant: 'primary',          
        okTitle: 'Close', 
        footerClass: 'p-2',
        hideHeaderClose: true,
        hideHeaderCancel: true,
        centered: true, 
        }); 
      }, 
    },
}
</script>
<style scoped>

</style>

